<div class="slider-step">
  <ngx-slider
    [(value)]="sliderValue"
    [options]="options"
    (userChange)="onUserChange($event)"></ngx-slider>
  <span class="label">{{ steps[stepIndex] }}</span>
</div>
